import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'adminConsole.fiduciarie.title',
    defaultMessage: 'Console gestione fiduciarie',
    description: 'Title of the Fiduciarie page',
  },
  breadcrumbFiduciarie: {
    id: 'adminConsole.fiduciarie.breadcrumb',
    defaultMessage: 'Gestione fiduciarie',
    description: 'Breadcrumb of the Fiduciarie page',
  },
  breadcrumbCreate: {
    id: 'adminConsole.fiduciarie.breadcrumbCreate',
    defaultMessage: 'Nuova utenza',
    description: 'Breadcrumb for create fiduciaria',
  },
  breadcrumbDetail: {
    id: 'adminConsole.fiduciarie.breadcrumbDetail',
    defaultMessage: 'Dettaglio utenza',
    description: 'Breadcrumb for the detail of a fiduciaria account',
  },
  widgetTitle: {
    id: 'adminConsole.fiduciarie.widgetTitle',
    defaultMessage: 'Ricerca utenze fiduciarie',
    description: 'Title of the search filter widget',
  },
  resultsSectionTitle: {
    id: 'adminConsole.fiduciarie.resultsSectionTitle',
    defaultMessage: 'Risultato ricerca fiduciaria',
    description: 'Title of the results section',
  },
  cardTitleNew: {
    id: 'adminConsole.fiduciarie.cardTitleNew',
    defaultMessage: 'Nuova utenza fiduciaria',
    description: 'Title of new fiduciaria card',
  },
  cardTitleDetail: {
    id: 'adminConsole.fiduciarie.cardTitleDetail',
    defaultMessage: 'Utenza fiduciaria {username}',
    description: 'Title of the fiduciaria detail card',
  },
  fiducianteSectionTitle: {
    id: 'adminConsole.fiduciarie.fiducianteSectionTitle',
    defaultMessage: 'Dati fiduciante',
    description: 'Title of the section with the fields of the fiduciante',
  },
  legalPersonSectionTitle: {
    id: 'adminConsole.fiduciarie.legalPersonSectionTitle',
    defaultMessage: 'Dati persona giuridica rappresentata',
    description:
      'Title of the section with the fields of the represented legal person',
  },
  nameInputLabel: {
    id: 'adminConsole.fiduciarie.nameInputLabel',
    defaultMessage: 'Nome',
    description: 'Label for name input field',
  },
  nameInputPlaceholder: {
    id: 'adminConsole.fiduciarie.nameInputPlaceholder',
    defaultMessage: 'Nome',
    description: 'Placeholder for name input field',
  },
  surnameInputLabel: {
    id: 'adminConsole.fiduciarie.surnameInputLabel',
    defaultMessage: 'Cognome',
    description: 'Label for surname input field',
  },
  surnameInputPlaceholder: {
    id: 'adminConsole.fiduciarie.surnameInputPlaceholder',
    defaultMessage: 'Cognome',
    description: 'Placeholder for surname input field',
  },
  actingPersonCodiceFiscaleInputLabel: {
    id: 'adminConsole.fiduciarie.actingPersonCodiceFiscaleInputLabel',
    defaultMessage: 'Codice fiscale',
    description:
      'Label for the codice fiscale of the acting person input field',
  },
  actingPersonCodiceFiscaleInputPlaceholder: {
    id: 'adminConsole.fiduciarie.actingPersonCodiceFiscaleInputPlaceholder',
    defaultMessage: 'Codice fiscale',
    description:
      'Placeholder for the codice fiscale of the acting person input field',
  },
  ragioneSocialeInputLabel: {
    id: 'adminConsole.fiduciarie.ragioneSocialeInputLabel',
    defaultMessage: 'Ragione sociale',
    description: 'Label for ragione sociale input field',
  },
  ragioneSocialeInputPlaceholder: {
    id: 'adminConsole.fiduciarie.ragioneSocialeInputPlaceholder',
    defaultMessage: 'Ragione sociale',
    description: 'Placeholder for ragione sociale input field',
  },
  codiceClienteRappresentanteInputLabel: {
    id: 'adminConsole.fiduciarie.codiceClienteRappresentanteInputLabel',
    defaultMessage: 'Codice cliente',
    description: 'Label for codice cliente rappresentante input field',
  },
  codiceClienteRappresentanteInputPlaceholder: {
    id: 'adminConsole.fiduciarie.codiceClienteRappresentanteInputPlaceholder',
    defaultMessage: 'Codice cliente',
    description: 'Placeholder for codice cliente rappresentante input field',
  },
  codiceFiscaleInputLabel: {
    id: 'adminConsole.fiduciarie.codiceFiscaleInputLabel',
    defaultMessage: 'Codice fiscale',
    description: 'Label for codice fiscale input field',
  },
  codiceFiscaleInputPlaceholder: {
    id: 'adminConsole.fiduciarie.codiceFiscaleInputPlaceholder',
    defaultMessage: 'Codice fiscale',
    description: 'Placeholder for codice fiscale input field',
  },
  partitaIvaInputLabel: {
    id: 'adminConsole.fiduciarie.partitaIvaInputLabel',
    defaultMessage: 'Partita IVA',
    description: 'Label for partita IVA input field',
  },
  partitaIvaInputPlaceholder: {
    id: 'adminConsole.fiduciarie.partitaIvaInputPlaceholder',
    defaultMessage: 'Partita IVA',
    description: 'Placeholder for partita IVA input field',
  },
  agentInputLabel: {
    id: 'adminConsole.fiduciarie.agentInputLabel',
    defaultMessage: 'Agente',
    description: 'Label for the trust company agent input field',
  },
  agentInputPlaceholder: {
    id: 'adminConsole.fiduciarie.agentInputPlaceholder',
    defaultMessage: 'Agente',
    description: 'Placeholder for the trust company agent input field',
  },
  addressBookInputLabel: {
    id: 'adminConsole.fiduciarie.addressBookInputLabel',
    defaultMessage: 'Codice rubrica',
    description: 'Label for address book input field',
  },
  addressBookInputPlaceholder: {
    id: 'adminConsole.fiduciarie.addressBookInputPlaceholder',
    defaultMessage: 'Codice rubrica',
    description: 'Placeholder for address book input field',
  },
  cellulareInputLabel: {
    id: 'adminConsole.fiduciarie.cellulareInputLabel',
    defaultMessage: 'Cellulare',
    description: 'Label for cellulare input field',
  },
  cellulareInputPlaceholder: {
    id: 'adminConsole.fiduciarie.cellulareInputPlaceholder',
    defaultMessage: 'Cellulare',
    description: 'Placeholder for cellulare input field',
  },
  emailInputLabel: {
    id: 'adminConsole.fiduciarie.emailInputLabel',
    defaultMessage: 'Email',
    description: 'Label for email input field',
  },
  emailInputPlaceholder: {
    id: 'adminConsole.fiduciarie.emailInputPlaceholder',
    defaultMessage: 'Email',
    description: 'Placeholder for email input field',
  },
  cleanFilters: {
    id: 'adminConsole.fiduciarie.cleanFilters',
    defaultMessage: 'Pulisci filtri',
    description: 'Label for clean filters button',
  },
  buttonConfirm: {
    id: 'adminConsole.fiduciarie.buttonConfirm',
    defaultMessage: 'Conferma',
    description: 'Label for confirm button',
  },
  buttonCancel: {
    id: 'adminConsole.fiduciarie.buttonCancel',
    defaultMessage: 'Annulla',
    description: 'Label for cancel button',
  },
  buttonBack: {
    id: 'adminConsole.fiduciarie.buttonBack',
    defaultMessage: 'Indietro',
    description: 'Label for the back button of the detail page',
  },
  buttonDelete: {
    id: 'adminConsole.fiduciarie.buttonDelete',
    defaultMessage: 'Elimina',
    description: 'Label for the delete button of the detail page',
  },
  createSuccess: {
    id: 'adminConsole.fiduciarie.createSuccess',
    defaultMessage: 'Utenza fiduciaria creata con successo',
    description: 'Success message after creation',
  },
  createError: {
    id: 'adminConsole.fiduciarie.createError',
    defaultMessage: "Errore durante la creazione dell'utenza fiduciaria",
    description: 'Error message after creation',
  },
  deleteConfirmTitle: {
    id: 'adminConsole.fiduciarie.deleteConfirmTitle',
    defaultMessage: "Eliminare l'utenza fiduciaria?",
    description: 'Title of the modal asking to confirm the delete',
  },
  deleteConfirmSubtitle: {
    id: 'adminConsole.fiduciarie.deleteConfirmSubtitle',
    defaultMessage:
      "L'utenza {username} di {trustCompany} verrà eliminata definitivamente.",
    description: 'Subtitle of the modal asking to confirm the delete',
  },
  deleteSuccess: {
    id: 'adminConsole.fiduciarie.deleteSuccess',
    defaultMessage: 'Utenza fiduciaria eliminata con successo',
    description: 'Success message after delete',
  },
  deleteError: {
    id: 'adminConsole.fiduciarie.deleteError',
    defaultMessage: "Errore durante l'eliminazione dell'utenza fiduciaria",
    description: 'Error message after delete',
  },
  errorRequiredFields: {
    id: 'adminConsole.fiduciarie.errorRequiredFields',
    defaultMessage: 'Compila tutti i campi obbligatori',
    description: 'Error when required fields are missing',
  },
  minLengthError: {
    id: 'adminConsole.fiduciarie.minLengthError',
    defaultMessage: 'Inserisci almeno {min} caratteri',
    description: 'Error when a search field is shorter than the minimum length',
  },
  requiredField: {
    id: 'adminConsole.fiduciarie.requiredField',
    defaultMessage: 'Campo obbligatorio',
    description: 'Error under a required field left blank',
  },
  fiscalDataRequired: {
    id: 'adminConsole.fiduciarie.fiscalDataRequired',
    defaultMessage: 'Inserisci il codice fiscale o la partita IVA',
    description:
      'Error under the trust company codice fiscale and partita IVA when neither is filled',
  },
  invalidField: {
    id: 'adminConsole.fiduciarie.invalidField',
    defaultMessage: 'Campo non valido',
    description: 'Error under a field rejected by the server',
  },
  invalidFiscalCode: {
    id: 'adminConsole.fiduciarie.invalidFiscalCode',
    defaultMessage: 'Codice fiscale non valido',
    description: 'Error when the codice fiscale is malformed',
  },
  invalidVatCode: {
    id: 'adminConsole.fiduciarie.invalidVatCode',
    defaultMessage: 'La partita IVA deve contenere 11 cifre',
    description: 'Error when the partita IVA is malformed',
  },
  createSuccessModalSubtitle: {
    id: 'adminConsole.fiduciarie.createSuccessModalSubtitle',
    defaultMessage:
      "Comunica le credenziali all'utente: la password temporanea non sarà più visibile dopo la chiusura.",
    description:
      'Subtitle of the modal with the credentials of the created account, shown once',
  },
  createdUsernameLabel: {
    id: 'adminConsole.fiduciarie.createdUsernameLabel',
    defaultMessage: 'Username',
    description: 'Label of the username in the created account modal',
  },
  createdTemporaryPasswordLabel: {
    id: 'adminConsole.fiduciarie.createdTemporaryPasswordLabel',
    defaultMessage: 'Password temporanea',
    description: 'Label of the temporary password in the created account modal',
  },
  createdAccountHolderLabel: {
    id: 'adminConsole.fiduciarie.createdAccountHolderLabel',
    defaultMessage: 'Utente',
    description: 'Label of the acting person in the created account modal',
  },
  createdTrustCompanyLabel: {
    id: 'adminConsole.fiduciarie.createdTrustCompanyLabel',
    defaultMessage: 'Fiduciaria',
    description: 'Label of the trust company in the created account modal',
  },
  searchError: {
    id: 'adminConsole.fiduciarie.searchError',
    defaultMessage: 'Errore durante la ricerca delle utenze fiduciarie',
    description: 'Error message after a failed search',
  },
  invalidFieldsDescription: {
    id: 'adminConsole.fiduciarie.invalidFieldsDescription',
    defaultMessage: 'Campi non validi: {fields}',
    description: 'List of the fields rejected by the server',
  },
  emailAlreadyInUse: {
    id: 'adminConsole.fiduciarie.emailAlreadyInUse',
    defaultMessage: "L'email indicata è già associata a un'altra utenza",
    description: 'Error when the email is already in use',
  },
  labelUsername: {
    id: 'adminConsole.fiduciarie.table.labelUsername',
    defaultMessage: 'Username',
    description: 'Username column label',
  },
  labelNominativoFiduciante: {
    id: 'adminConsole.fiduciarie.table.labelNominativoFiduciante',
    defaultMessage: 'Nominativo fiduciaria',
    description: 'Acting person name and surname column label',
  },
  labelCodiceClienteRappresentante: {
    id: 'adminConsole.fiduciarie.table.labelCodiceClienteRappresentante',
    defaultMessage: 'Codice cliente',
    description: 'Trust company code column label',
  },
  labelRagioneSocialeFiduciaria: {
    id: 'adminConsole.fiduciarie.table.labelRagioneSocialeFiduciaria',
    defaultMessage: 'Ragione sociale',
    description: 'Trust company name column label',
  },
  labelAgente: {
    id: 'adminConsole.fiduciarie.table.labelAgente',
    defaultMessage: 'Agente',
    description: 'Trust company agent column label',
  },
  labelCodiceFiscaleFiduciaria: {
    id: 'adminConsole.fiduciarie.table.labelCodiceFiscaleFiduciaria',
    defaultMessage: 'Codice fiscale fiduciaria',
    description: 'Trust company codice fiscale column label',
  },
  labelPartitaIvaFiduciaria: {
    id: 'adminConsole.fiduciarie.table.labelPartitaIvaFiduciaria',
    defaultMessage: 'Partita IVA fiduciaria',
    description: 'Trust company partita IVA column label',
  },
  labelNomeRappresentante: {
    id: 'adminConsole.fiduciarie.table.labelNomeRappresentante',
    defaultMessage: 'Nome rappresentante',
    description: 'Acting person name column label',
  },
  labelCognomeRappresentante: {
    id: 'adminConsole.fiduciarie.table.labelCognomeRappresentante',
    defaultMessage: 'Cognome rappresentante',
    description: 'Acting person surname column label',
  },
  labelCodiceFiscaleFiduciante: {
    id: 'adminConsole.fiduciarie.table.labelCodiceFiscaleFiduciante',
    defaultMessage: 'Codice fiscale fiduciante',
    description: 'Acting person codice fiscale column label',
  },
  labelCodiceRubrica: {
    id: 'adminConsole.fiduciarie.table.labelCodiceRubrica',
    defaultMessage: 'Codice rubrica',
    description: 'Address book column label',
  },
  labelNumeroCellulare: {
    id: 'adminConsole.fiduciarie.table.labelNumeroCellulare',
    defaultMessage: 'Cellulare',
    description: 'Numero di cellulare column label',
  },
  labelEmail: {
    id: 'adminConsole.fiduciarie.table.labelEmail',
    defaultMessage: 'Email',
    description: 'Email column label',
  },
  noResults: {
    id: 'adminConsole.fiduciarie.table.noResults',
    defaultMessage: 'Nessun risultato trovato',
    description: 'No results message',
  },
});
